import { render, staticRenderFns } from "./BaseRecord.vue?vue&type=template&id=21299edc&scoped=true&"
import script from "./BaseRecord.vue?vue&type=script&lang=js&"
export * from "./BaseRecord.vue?vue&type=script&lang=js&"
import style0 from "./BaseRecord.vue?vue&type=style&index=0&id=21299edc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21299edc",
  null
  
)

export default component.exports